(function () {
	angular
		.module('trackeye')
		.directive('mustEqual', mustEqual);

	/**
	 * Compare two input fields against each other
	 */
	function mustEqual() {
		return {
			require: "ngModel",
			restrict: "A",
			scope: {
				mustEqual: "="
			},
			link: function (scope, element, attributes, ngModel) {
				ngModel.$validators.mustEqual = function (modelValue) {
					return modelValue === scope.mustEqual;
				};

				scope.$watch("mustEqual", function () {
					ngModel.$validate();
				});
			}
		};
	}
})();